import { Component, OnInit ,HostListener ,EventEmitter ,Input ,Output } from '@angular/core';
import { Category ,CategoryItem, AboutRestaurant, FoodItem} from 'src/app/models/category';
import { ChangeFood,OrderAdditon , RestaurantItem, Restaurant, CategoryRestaurant} from 'src/app/models/restaurant'
import { Router ,ActivatedRoute, RouterEvent, NavigationStart} from '@angular/router';
import { AppProxy } from 'src/app/services/app-proxy';
import { BussinssService } from 'src/app/services/bussinss-service';
import { OrdersService } from 'src/app/services/order-service';
import { MyOrder, OrderAdding } from 'src/app/models/order';
import { elementEventFullName } from '@angular/compiler/src/view_compiler/view_compiler';
import { AppComponent } from 'src/app/app.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BigImageComponent } from '../big-image/big-image.component';
import { DataService } from 'src/app/services/data.service';
import { PopupOrderComponent } from '../popup-order/popup-order.component';
import { DialogOutOfBoundsComponent } from '../dialog-out-of-bounds/dialog-out-of-bounds.component';
import { Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

@Component({
  selector: 'app-restaurant',
  templateUrl: './restaurant.component.html',
  styleUrls: ['./restaurant.component.css']
})
export class RestaurantComponent implements OnInit {
  @Output()changePrice: EventEmitter<number> = new EventEmitter<number>();
  @Output()changeShowPrice: EventEmitter<number> = new EventEmitter<number>();
  @Output()changByFood: EventEmitter<number> = new EventEmitter<number>();
  @Output()changText: EventEmitter<number> = new EventEmitter<number>();
   @Output()header: EventEmitter<number> = new EventEmitter<number>();
  stars:number[]=[1,2,3,4,5];
  categores:CategoryRestaurant[];
  categoresItem:CategoryItem[];
  restaurantItem:RestaurantItem[]=[];
  changeFood:ChangeFood[];
  toppingsDish:OrderAdditon[];
  foodItem:FoodItem[];
  showChangeFood:boolean=false;
  aboutRestaurantCheck='assets/images/Circle_On.png';
  buttonText="העגלה ריקה";
  totalItems:number=0;
  totalAmount:number=0.0;
  amountFood:number[];
  restaurant:Restaurant=new Restaurant;
  order:MyOrder;
  id:number;
  orderAddingList:OrderAdditon[];
  Rate= new Array<number>(3);
  clickFevorite=false;
  fevorit='assets/images/Restorant_Page_Fevorit_Button.png';
  fevoritActive='assets/images/Restorant_Page_Fevorit_Button_On.png';
  Name:string="";
  priceTotal="0 - פריטים"
  price=0;
  clickToPay=" מעבר לסיכום הזמנה - "
  categoryToFilter="";
  foodName:string;
  dayTime="סגור";
  num=0;
  page:number=1;
  sum = 100;
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  direction = "";
  text:string;
  Image:string="";
  MenuList:RestaurantItem[]=[];
  orderOpen:boolean=false;
  endToppings=true;
  categoryFilter=0;
  showProgress=false;
  show=true;
  animal: string;
  name: string;
isChangeOnFood=false
isPopupOpen = false;

  selectedDish: RestaurantItem | null = null;
  private routeSub: Subscription;

  openPopup(dish: RestaurantItem) {
    this.selectedDish = dish;
    this.selectedDish.restaurantID = this.restaurant.ID;
    this.isPopupOpen = true;
    document.body.style.overflow = 'hidden';
  }

  closePopup() {
    if (this.isChangeOnFood == false)
    {
      this.minus(localStorage.pos)
    }
    else
    {
      this.isChangeOnFood = false
    }
   
    this.isPopupOpen = false;
    this.selectedDish = null;
    document.body.style.overflow = 'auto';
  }
  saveSet() {
    this.isChangeOnFood = false
    this.isPopupOpen = false;
    this.selectedDish = null;
    document.body.style.overflow = 'auto';
   this.orderService.getOrderDetails(false).subscribe((res:any)=>{
       this.order=res;
       this.totalAmount=Number(this.order.TotalPrice);

       localStorage.PRICE=this.totalAmount;
       this.priceTotal=this.clickToPay+this.totalAmount+" ₪";
       this.dataService.price.next(this.priceTotal);
      this.changePrice.emit();
     this.showProgress=false;
   
  
      this.dataService.endToppings.next(false);
      this.header.emit();
      this.dataService.notEndToppings=false;
      if (this.order?.list) {
  // Create a map to sum counts by MenuID
  const countMap = new Map<number, number>();
  this.order.list
    .filter(orderItem => orderItem.Count > 0)
    .forEach(orderItem => {
      countMap.set(
        orderItem.MenuID,
        (countMap.get(orderItem.MenuID) || 0) + orderItem.Count
      );
    });

  // Set the Rate for each restaurant item
  this.restaurantItem.forEach(item => {
    if (countMap.has(item.ID)) {
      item.Rate = countMap.get(item.ID);
    }
  });
}
     this.processAdditionalItems()
    
     });
   
  }

   private processAdditionalItems() {
  let amount = 0
this.restaurantItem
//.filter(item => item.IsAddition === 1)
.forEach(item => {
  // Initialize or reset ChangeFood array
  item.ChangeFood = [];
  
  // Create ChangeFood entries based on Rate
  if (item.Rate) {
    for (let i = 0; i < item.Rate; i++) {
      const changeFood = new ChangeFood();
      changeFood.Text = "לחץ לשינויים";
      changeFood.toppings = null;
      changeFood.Name = `${i + 1}-${item.Name}`;
      item.ChangeFood.push(changeFood);
    }
    amount += item.Rate; // Assuming amount is defined in class scope
  }
});
return amount
}
  async ngOnInit(): Promise<void>{
      this.toStartData();
      this.orderOpen = this.dataService.orderOpen.getValue() || {};
        if(localStorage.ID!="0")
        {
      if(this.categoryToFilter=="")
      {
        this.id=localStorage.ID;
     
      }
        else if(this.restaurant.ID!=undefined)
        {
        this.id=this.restaurant.ID;
        }
        else
        {
        this.id=localStorage.ID_CATEGORY;
        }
        }

      this.categoryFilter=sessionStorage.CATEGORY_FILTER;
     if(this.categoryToFilter==null)
        {this.categoryToFilter=""; }

        if ( localStorage.ACCESS_TOKEN != "null" && localStorage.ACCESS_TOKEN != null &&(this.orderService.order == null 
          || this.orderService.order.OrderID == 0 ))
          {
        this.orderService.getOrderDetails(false).subscribe(async (res:any)=>{
          this.order=this.orderService.order;
         // this.order=res;
           if(this.order !=null && Number(this.order.TotalPrice)>0)
            {
            
            this.priceTotal =  this.orderService.order.TotalPrice+" ₪"
              //naomi ניסיון לשנות
          this.priceTotal=this.clickToPay+" "+this.order.TotalPrice+" ₪";
     
         

            }
           else
              this.priceTotal="0 - פריטים";
              if(this.order!=null && this.order.list!=null && this.order.list.length!=0 && localStorage.edit=="false")
              {
                let pos=this.order.list.length;
                if(pos>0)
                {
                pos=Number(Number(pos)-1);
        }
        }
     
         //to chack here
         localStorage.PRICE_TOTAL=this.priceTotal;
         this.dataService.price.next(this.priceTotal);
         this.changePrice.emit();
        
      

         this.routeSub = await this.gg()
            localStorage.edit="false"
         console.log ("finish4")
         return
    });
  }
 //_______________________________________________________________
  else {
       this.order=this.orderService.order;
        if(this.order !=null && Number(this.order.TotalPrice)>0)
         {
        this.priceTotal =  this.orderService.order.TotalPrice+" ₪"
       this.priceTotal=this.clickToPay+" "+this.order.TotalPrice+" ₪";
         }
        else
           this.priceTotal="0 - פריטים";
           if(this.order!=null && this.order.list!=null && this.order.list.length!=0 && localStorage.edit=="false")
           {
             let pos=this.order.list.length;
             if(pos>0)
             {
             pos=Number(Number(pos)-1);
     }
     }
  
      localStorage.PRICE_TOTAL=this.priceTotal;
      this.dataService.price.next(this.priceTotal);
      this.changePrice.emit();
    
      this.routeSub =  await this.gg()
         localStorage.edit="false"
     console.log ("finish1")
 }

}

 async  gg()
       {
      
    return this.route.params.subscribe(params => {
     let urlId=params['id'];
     if(urlId!=undefined)
     {
    this.bussinssService.getBusinessIDByEnName(urlId).subscribe((res:any)=>{
     this.id=Number(res);
       if(this.id==undefined || this.id==null)
        {
        if(localStorage.ID!="0")
        if(this.categoryToFilter=="")
        {
          this.id=localStorage.ID;
         
        }
          else if(this.restaurant.ID!=undefined)
          {
          this.id=this.restaurant.ID;
      
          }
          else
        {
          this.id=localStorage.ID_CATEGORY;
       
        }
        }
         else 
       if(this.order==null ||this.order.OrderID==0 ||this.order==undefined)
        {
        
            let i=0;
            localStorage.TEXT_SEARCH="";
            sessionStorage.CATEGORY_FILTER=i;
         
            if(this.categores!=null)
            for(let j=0;j<this.categores.length;j++)
            {
              if(j!=i)
              this.categores[j].isCheck=0;
            }
            if(i>-1)
            {
            if(this.categores!=null && this.categores.length>0)
            {
               this.categores[i].isCheck=1;
               this.categoryToFilter=this.categores[i].Category;
            }
              if(sessionStorage.deeplink=="")
              {
              if(localStorage.ID!="0") 
              if(this.categoryToFilter=="")
                this.id=localStorage.ID;
                else
                this.id=this.restaurant.ID;
                else
                this.id=this.restaurant.ID;
              }
              if(this.categoryToFilter==null)
              this.categoryToFilter="";
              this.bussinssService.getRestaurantDetails(this.id,false,false,false,this.categoryToFilter,null).subscribe((res:any)=>{
                this.restaurant=res;
                this.restaurantItem=this.restaurant.MenuList;
                let KashrutLength=0;
                if (this.restaurant.Kashrut!=null)
                KashrutLength=this.restaurant.Kashrut.length;
              this.orderService.restaurant=this.restaurant;
                if(this.restaurant.LongImage!=null)
                this.Image=this.restaurant.LongImage;
                this.restaurantItem=this.restaurant.MenuList;
                if(this.restaurantItem!=null)
                         for(let i=0;i<this.restaurantItem.length;i++)
                  {
                    if(this.restaurantItem[i].Rate==undefined)
                    this.restaurantItem[i].Rate=0;
                    else if(this.restaurantItem[i].Rate>0)
                    {
                      this.buttonText="המשך לתשלום";
                    this.totalItems+=this.restaurantItem[i].Rate;
                   let p=0.0;
                   p=this.restaurantItem[i].Price;
                   this.totalAmount=Number(this.totalItems)*Number(p);
                    }
                  }
                   this.order=this.orderService.order;
                 if(this.restaurant.MenuList.length>0)
                 {
                  if (this.order?.list) { 
                     this.order.list .filter(orderItem => orderItem.Count > 0)  // Only process items with count > 0
                      .forEach(orderItem => {
                        const matchingItem = this.restaurantItem.find(
                          item => item.ID === orderItem.MenuID
                        );
                        
                        if (matchingItem) {
                          matchingItem.Rate += orderItem.Count;
                          if (orderItem.IsAdditionRequired == 1 && orderItem.listSets.length == 0)
                          {
                            this.openPopup(matchingItem);
                          }
                        }
                      });
                  }
 this.processAdditionalItems()
  if(localStorage.PRICE>0)
                  this.totalAmount=Number(localStorage.PRICE)
                  else
                  {
                   this.totalAmount=0;
                 for(let i=0;i<this.restaurant.MenuList.length;i++)
                 {
                   if(this.restaurant.MenuList[i].Rate>0)
                   {
                     let p:number=0;
                     p=this.restaurant.MenuList[i].Price;
                     this.totalAmount+=Number(this.restaurantItem[i].Rate)*Number(p);
                     this.totalItems+=this.restaurantItem[i].Rate;
                   }
                 }
               }
            
         
               }
                 if(this.order!=null && this.order.OrderID!=0)
                   {
                     let haveList=false;
                     let pos=-1;
                     for(let j=0;j<this.restaurantItem.length;j++)
                   
                   {
                      haveList=false;
                      pos=-1;
                      for(let i=0;i<this.order.list.length;i++)
                     {
                 
                     if(this.restaurantItem[j].Rate>0)
                     {
                       pos=j;
                     if(this.order.list[i].MenuID==this.restaurantItem[j].ID)
                     {
                        haveList=true;
                        i=this.order.list.length;
                     }
                   }
                     }
                     if(pos>0 && haveList==false)
                     {
                     this.restaurantItem[pos].Rate=0;
                     let location = this.restaurantItem[pos].ChangeFood.length-1;
                     this.restaurantItem[pos].ChangeFood.splice(this.restaurantItem.length-1,1);
                     delete this.restaurantItem[pos].ChangeFood[location]; 
                     this.restaurantItem[pos].ChangeFood.length=location;
                     let p:number=0;
                     p=this.restaurantItem[pos].Price;
                     this.totalAmount-=Number(this.restaurantItem[pos].Rate)*Number(p);
                     this.totalItems-=this.restaurantItem[pos].Rate;
                   }
                   }
                   } 
             
              });
            }
           
        this.bussinssService.getRestaurantDetails(this.id,false,false,false,this.categoryToFilter,null).subscribe((res:any)=>{
          console.log("6getRestaurantDetails")
         this.getRestaurantDetails(res,0);
 });
}
else
{
  if (this.bussinssService.restaurant != null && this.bussinssService.restaurant.ID === this.id) 
  {
    console.log("66getRestaurantDetails")
this.getRestaurantDetails(this.bussinssService.restaurant,-1);
  }
  else
  {
    this.bussinssService.getRestaurantDetails(this.id,false,false,false,this.categoryToFilter,null).subscribe((res:any)=>{
      console.log("88getRestaurantDetails")
      this.getRestaurantDetails(res,0);
    });
  }
}

    }
  )
     }
     else
      {
        if(this.order==null ||this.order.OrderID==0 ||this.order==undefined || this.bussinssService ==null || this.bussinssService.restaurant == null )
         {
         this.bussinssService.getRestaurantDetails(this.id,false,false,false,this.categoryToFilter,null).subscribe((res:any)=>{
          console.log("77getRestaurantDetails")
          this.getRestaurantDetails(res,0);
  });
 }
 else
 {
  console.log("67getRestaurantDetails")
this.getRestaurantDetails(this.bussinssService.restaurant,-1);
return
 }
}
      })
          }

  
 toStartData()
   {
   
    this.matDialog.closeAll();
    localStorage.DELIVERY=0;

//להראות את הכפתור לחץ לתשלום

    this.proxy.scrollToTop();
    this.header.emit();
    this.showProgress=true;
    this.dataService.byFood.next(true);
    this.changByFood.emit();
    this.dataService.show.next(true);
    this.changeShowPrice.emit();
    this.dataService.showSearch.next(true);
    this.changByFood.emit();
    localStorage.SHOW=true;
    
    this.orderService.orderAddingList=null;
   }


   getRestaurantDetails(restaurant : Restaurant,num : number)
    {
    
        if (!restaurant) {
            console.error('Restaurant is undefined');
            return;
        }
     
        this.restaurant = restaurant;
        this.restaurantItem = this.restaurant.MenuList || [];
         console.log(this.restaurant.MenuList)
        this.restaurantItem=this.restaurant.MenuList;
      let KashrutLength=0;
      if (this.restaurant!= null && this.restaurant.Kashrut!=null)
      KashrutLength=this.restaurant.Kashrut.length;
     
    
      this.categores=this.restaurant.categoryList;
      let cc=0;
      if(this.categoryToFilter=="")
      cc=1;
      this.categoryToFilter=this.categores[0].Category;
     
      
   let pos:number=Number(sessionStorage.CATEGORY_FILTER);
 
  if( pos>-1 && Number(this.categores.length-1)>= pos)
  {
  this.categoryToFilter=this.categores[pos].Category;
  
 
  }
  if(num >- 1)
  {
    let b=0;
    for(let i=0;i<this.restaurant.ListDay.length;i++)
    {
      if(i==new Date().getDay())
      {
      if(new Date().getHours()<=5)
      {
         if(i>0)
         {
        i=i-1
        b=1;
         }
         else
         {
         i=6;
         b=7;
         }
      }
  
    if(this.restaurant.ListDay[i].DayTime!='' && this.restaurant.ListDay[i].DayTime!='0:00-0:00' && this.restaurant.ListDay[i].DayTime!='00:00-00:00')
     {
       var fields = this.restaurant.ListDay[i].DayTime.split('-');
    //   if(this.proxy.isOpen(fields[0],fields[1],b))
       this.dayTime=this.restaurant.ListDay[i].DayTime;

     }
      else
      this.dayTime="סגור";

      i=this.restaurant.ListDay.length;
      }
     }
  
      this.category(pos);
      this.showProgress=false;
      
    }

    
    else
    {
      this.showProgress=false;   
      if(this.restaurant.LongImage!=null)
      this.Image=this.restaurant.LongImage;
 
  {
    if(this.MenuList.length!=0)
    this.restaurantItem= this.MenuList;
   if(this.restaurant.MenuList!=null)
      this.restaurantItem=this.restaurant.MenuList; 
 
      if(this.restaurantItem!=null)
      for(let i=0;i<this.restaurantItem.length;i++)
        {
          if(this.restaurantItem[i].Rate==undefined)
          this.restaurantItem[i].Rate=0;
          else if(this.restaurantItem[i].Rate>0)
          {
            this.buttonText="המשך לתשלום";
          this.totalItems+=this.restaurantItem[i].Rate;
         let p=0.0;
         p=this.restaurantItem[i].Price;
         this.totalAmount=Number(this.totalItems)*Number(p);
          }
        }}
        if(this.restaurant!=null)
        {
        let b=0;
          for(let i=0;i<this.restaurant.ListDay.length;i++)
          {
            if(i==new Date().getDay())
            {
            if(new Date().getHours()<=5)
            {
               if(i>0)
               {
              i=i-1
              b=1;
               }
               else
               {
               i=6;
               b=7;
               }
            }
        
              if(this.restaurant.ListDay[i].DayTime!='' && this.restaurant.ListDay[i].DayTime!='0:00-0:00' && this.restaurant.ListDay[i].DayTime!='00:00-00:00')
           {
          
             var fields = this.restaurant.ListDay[i].DayTime.split('-');
         
              this.dayTime=this.restaurant.ListDay[i].DayTime;
             
           }
            else
            this.dayTime="סגור";
            i=this.restaurant.ListDay.length;
            }
          }
          if(localStorage.PRICE>0)
          this.totalAmount=Number(localStorage.PRICE);
       
         if(this.restaurant.Name!=null)
        this.Name=this.restaurant.Name;
        }
        else{
        }
       
    if(this.restaurantItem!=null && this.restaurantItem.length>0)
    this.buttonText="המשך לתשלום"
        if(this.restaurant!=null)
      {

      }
      else{
    
      }
     if(this.restaurant.MenuList.length>0)
     {
  
       
this.processAdditionalItems()
      
      if(localStorage.PRICE>0)
      this.totalAmount=Number(localStorage.PRICE)
      else
      {
       this.totalAmount=0;
     for(let i=0;i<this.restaurant.MenuList.length;i++)
     {
       if(this.restaurant.MenuList[i].Rate>0)
       {
         let p:number=0;
         p=this.restaurant.MenuList[i].Price;
         this.totalAmount+=Number(this.restaurantItem[i].Rate)*Number(p);
         this.totalItems+=this.restaurantItem[i].Rate;
       }
     }
    
   }
   }
     if(this.order!=null && this.order.OrderID!=0)
       {
         let haveList=false;
         let pos=-1;
         for(let j=0;j<this.restaurantItem.length;j++)
       
       {
          haveList=false;
          pos=-1;
          for(let i=0;i<this.order.list.length;i++)
         {
     
         if(this.restaurantItem[j].Rate>0)
         {
           pos=j;
         if(this.order.list[i].MenuID==this.restaurantItem[j].ID)
         {
            haveList=true;
            i=this.order.list.length;
         }
       }
         }
         if(pos>0 && haveList==false)
         {
       
         this.restaurantItem[pos].Rate=0;
         let location = this.restaurantItem[pos].ChangeFood.length-1;
         this.restaurantItem[pos].ChangeFood.splice(this.restaurantItem.length-1,1);
         delete this.restaurantItem[pos].ChangeFood[location]; 
         this.restaurantItem[pos].ChangeFood.length=location;
         let p:number=0;
         p=this.restaurantItem[pos].Price;
         this.totalAmount-=Number(this.restaurantItem[pos].Rate)*Number(p);
         this.totalItems-=this.restaurantItem[pos].Rate;
         localStorage.PRICE= Number(this.totalAmount);
       }
       else
       {
        if (this.order.OrderID != 0)
          {
       
        let i=0
        for(i;i<this.categores.length;i++)
        {
          if (this.categores[i].isCheck == 1)
          {
            return
          }

        }

        if (i == this.categores.length)

       {
          this.categores[0].isCheck=1;
          this.categoryToFilter=this.categores[0].Category;
          this.category(0)
        }
       // this.category(this.categores)

       }
      }
       }
     
       }
      
      }
  this.endToppings = this.dataService.notEndToppings
    if(this.endToppings==true)
    {
     return;
    }

  this.text = this.dataService.search.getValue() || {};
  this.dataService.search.subscribe(data=>{
    this.text=data;
  
  if(this.text!="")
  {
    console.log("76")
    if(sessionStorage.CATEGORY_FILTER!="")
    this.categoryFilter=sessionStorage.CATEGORY_FILTER;
    else
    this.categoryToFilter="";
  
    if(localStorage.ID!="0")
    if(this.categoryToFilter=="")
    {
      this.id=localStorage.ID;
    
    }
      else
      {
      this.id=this.restaurant.ID;
  
      }
       if(this.id==undefined)
       {
       this.id=this.restaurant.ID;
     
       }
       let id_:number=localStorage.ID
       if(id_ !=undefined &&   localStorage.TEXT_SEARCH!="")
    this.bussinssService.getBusinessMenuBySearch(id_,this.text,1).subscribe((res:any[])=>{
      this.restaurant.MenuList=res;
      if(this.restaurant.MenuList!=null)
      {
      this.restaurantItem=this.restaurant.MenuList;
      this.MenuList=[];
      this.dataService.text.next("");
      this.changText.emit();
      }
      else
      {
      this.proxy.showError("לא נמצאו מנות\n בקטגוריה זו","");
      this.dataService.text.next("");
      this.changText.emit();
      }
    });

  }
  console.log("788")
});

    }

  onBackPress()
  {
     localStorage.back='true'
     
          if(localStorage.Category=="2")
          {
            let url: string;
         
             url= "/restaurantCategory/" + sessionStorage.Category;
        
            this.router.navigateByUrl(url);
         
          }
          else
          this.router.navigate(["../mainHome"]);
  }
payment()
  {
    this.restaurant.MenuList=this.restaurantItem;
    this.orderService.restaurant=this.restaurant;
    if(this.totalAmount>0)
    {
      let canContinue = true;
           this.orderService.getOrderDetails(false).subscribe((res:any)=>{
           
       this.order=res;
      if(this.order!=null && this.order.list!=null)
      for(let i=0;i<this.order.list.length;i++)
      {
        let orderList=this.order.list[i];
          for(let j=0;j<this.restaurant.MenuList.length;j++) {
              let categoryItemFood = this.restaurant.MenuList[j];
              if (orderList.IsAddition == 1)
                  if (orderList.MenuID == categoryItemFood.ID)
                      if(categoryItemFood.IsAdditionRequired==1) {
                  
                          if (orderList.listSets.length==0) {
                              canContinue = false;
                              j=this.restaurant.MenuList.length;
                          }
                      }
          }
      }
      if(canContinue==true)
      {
    this.router.navigate(["../yourOrder"]);
    localStorage.SHOW=false;
      }
    else
    this.proxy.showError("לא בחרת \n את כל תוספות החובה","");
    });
}
    else
    this.proxy.showError("ההזמנה ריקה","");
  }


  restaurantType(i)
  {

  }

  openOutOfBoundsDialog(): void {
    const dialogRef = this.matDialog.open(DialogOutOfBoundsComponent, {
      data: {name: this.name, animal: this.animal},
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.matDialog.closeAll();
      this.animal = result;
    });
  }

  onScrollDown() {
    this.appendItems();
    this.direction = "down";
  }

  onUp() {
    this.sum += 20;
    //this.prependItems();
    this.direction = "up";
  }

  prependItems() {
    this.addItems();
  }

  appendItems() {
    // this.addItems();
  }

  addItems() {
    this.page=Number(this.page)+1;
    if(this.id>-1)
    {
      this.bussinssService.getMainList(5,this.id,this.page,Math.floor((Math.random() * 20) + 1)).subscribe((res:any[])=>{
        if(this.restaurantItem==null)
        this.restaurantItem=[];
        for(let i=0;i<res.length;i++)
        {
        this.restaurantItem.push(res[i]);
        }
    });
  }
  else
  {
    if(this.text!='')
    this.bussinssService.getMenuBySearch(this.text,this.page).subscribe((res:any[])=>{
      if(this.restaurantItem==null)
      this.restaurantItem=[];
      for(let i=0;i<res.length;i++)
      {
      this.restaurantItem.push(res[i]);
      }
    });
  }
  }

  backPress()
  {
  }

   constructor(private route: ActivatedRoute,private dataService:DataService,private matDialog:MatDialog,private router: Router,private orderService:OrdersService,private proxy :AppProxy,private bussinssService: BussinssService) {
        router.events.pipe(
      filter((event: RouterEvent) => event instanceof NavigationStart),
      tap(() => this.matDialog.closeAll())
    )   .subscribe(() => {
      this.initializePage();
    });
   }
private initializePage(): void {
  // Your initialization logic here
  if (this.router.url.startsWith("/yourOrder") && localStorage.edit != "true")
 {
 
  this.restaurantItem = null;
   this.showProgress=true;
  this.category((localStorage.CATEGORY_FILTER))
 }

}

   plus(MenuID:number, pos:number ,position:number)
   {
     localStorage.TEXT_SEARCH="";
     if(localStorage.ACCESS_TOKEN  != "null"  &&  localStorage.SMS_CODE!="")
     {
        if(this.dayTime=="סגור" ||  (this.restaurant.IsOpen == 0 || this.restaurant.IsTemporaryClosed == 1))
    {
      this.proxy.showError("המסעדה סגורה\n אין אפשרות לבצע הזמנה","");
      return
    }
       this.totalItems+=1;
      this.restaurantItem[pos].Rate+=1;

      if(this.restaurantItem[pos].ChangeFood==null)
        this.restaurantItem[pos].ChangeFood=[];
     {
     this.orderService.addToBagOrder_(this.restaurantItem[pos].ID,this.restaurant.ID,this.restaurantItem[pos].Rate).subscribe((res:any)=>{

         let changeFood = new ChangeFood();
         let amount=0;
         if(this.restaurantItem[pos].Rate!=null)
            amount=this.restaurantItem[pos].Rate;
         changeFood.Name =(amount)+'-'+ this.restaurantItem[pos].Name;
         changeFood.Text="לחץ לשינויים ";
        changeFood.toppings =null; 
         this.restaurantItem[pos].ChangeFood.push(changeFood);
         
         this.restaurant.MenuList=this.restaurantItem;
     if(this.orderService.restaurant==null)
     this.orderService.restaurant=this.restaurant;
     if(this.restaurant!=null && this.restaurant.MenuList!=null)
     this.orderService.restaurant.MenuList=this.restaurant.MenuList;
     localStorage.PRICE=Number(this.totalAmount);
     localStorage.ITEM=Number(this.totalItems);
     localStorage.MENU_ID=MenuID;
     localStorage.MENU_NUMBER=position + 1;
     let a:number=1;
     position=Number(position+a);
     this.dataService.show.next(true);
      this.changeShowPrice.emit();
      localStorage.position=position;
      localStorage.pos=pos;
      localStorage.edit="false";
       this.openPopup( this.restaurantItem[pos]);
 
     }); 
 }
 }
 else{
   this.proxy.showError("אינך רשום למערכת נא להרשם","");
   this.router.navigate(['../mainHome']);
 }
   }
 
   minus(i)
   {
     localStorage.TEXT_SEARCH="";
     if(this.restaurantItem[i].Rate>0)
     {
      this.totalItems=0;
      let p:number=0;
      p=this.restaurantItem[i].Price;

      const numA = parseFloat(String(this.totalAmount));
      const numB = parseFloat(String(p));
       this.totalAmount=(numA - numB);
     this.restaurantItem[i].Rate-=1;
    if(this.totalAmount>0)
    for(let i=0;i<this.restaurantItem.length;i++)
    {
      if(Number(this.restaurantItem[i].Rate)>0)
      this.totalItems+=Number(this.restaurantItem[i].Rate);
    }
     let changeFood = new ChangeFood();
     let location:number;
     if(this.restaurantItem[i].ChangeFood!=null)
     {
     location = this.restaurantItem[i].ChangeFood.length-1;
     this.restaurantItem[i].ChangeFood.splice(this.restaurantItem.length-1,1);
     }
     this.orderService.getOrderDetails(false).subscribe((res:any)=>{
       console.log("getOrderDetails4","getOrderDetails");    
       this.order=res;
       let menuId=-1;
       for(let n=0;n<this.order.list.length;n++)
       {
 if(this.order.list[n].MenuID==this.restaurantItem[i].ID)
 menuId=n;
       }
      this.showProgress=true;
     this.orderService.addToBagOrder(this.order.list[menuId].ID,this.order.OrderID,this.order.list[menuId].MenuNumber).subscribe((res:any)=>{
 
     if(this.restaurantItem[i].ChangeFood!=null && this.restaurantItem[i].ChangeFood.length>location)
     delete this.restaurantItem[i].ChangeFood[location]; 
     if(this.restaurantItem[i].ChangeFood!=null && this.restaurantItem[i].ChangeFood.length<0)
     this.restaurantItem[i].ChangeFood.length=location;
     if(this.restaurantItem[i].Rate==0)
     this.restaurantItem[i].ChangeFood=null;
     if(this.order.list[menuId].MenuNumber>=1)
     {
      this.orderService.getOrderDetails(false).subscribe((res:any)=>{
        this.showProgress=false;
       console.log("getOrderDetails5","getOrderDetails");    
        this.order=res;
        if(this.order.list.length==0)
        {
     this.totalAmount=0;
     this.priceTotal="0 - פריטים";
     localStorage.PRICE=0;
     localStorage.PRICE_TOTAL=this.priceTotal;
     this.dataService.price.next(this.priceTotal);
     this.changePrice.emit();
        }
        else{
         this.showProgress=false;
         this.totalAmount=Number(this.order.TotalPrice);
         this.priceTotal=this.clickToPay+" "+this.totalAmount+" ₪";
         localStorage.PRICE_TOTAL=this.priceTotal;
         this.dataService.price.next(this.priceTotal);
         this.changePrice.emit();
        }
   
        });
       }
       else{
         this.showProgress=false;
         this.order.list[menuId].MenuNumber-=1;
         const numA = parseFloat(String(this.order.TotalPrice));
         const numB = parseFloat(String(this.order.list[menuId].Price));
          this.totalAmount=(numA - numB);

         //this.totalAmount=Number(Number(this.order.TotalPrice)-Number(this.order.list[menuId].Price));
         this.order.TotalPrice=this.totalAmount.toFixed(2);
         this.priceTotal=this.clickToPay+" "+this.totalAmount.toFixed(2)+" ₪";
         localStorage.PRICE_TOTAL=this.priceTotal;
         this.dataService.price.next(this.priceTotal);
         this.changePrice.emit();
       }
      });
     });
   }
   }


   category(i){
     sessionStorage.CATEGORY_FILTER=i;
     for(let j=0;j<this.categores.length;j++)
     {
       if(j!=i)
       this.categores[j].isCheck=0;
     }
     if(i>-1)
     {
     {
        this.categores[i].isCheck=1;
        this.categoryToFilter=this.categores[i].Category;
     }

       if(localStorage.ID!="0")
       if(this.categoryToFilter=="")
         this.id=localStorage.ID;
         else
         this.id=this.restaurant.ID;
       if(this.categoryToFilter==null)
       this.categoryToFilter="";
       this.bussinssService.getRestaurantDetails(this.id,false,false,false,this.categoryToFilter,null).subscribe((res:any)=>{
         this.restaurant=res;
         this.orderService.restaurant=this.restaurant;
         if(this.restaurant.LongImage!=null)
         this.Image=this.restaurant.LongImage;
         this.restaurantItem=this.restaurant.MenuList;
         if(this.restaurantItem!=null)
         for(let i=0;i<this.restaurantItem.length;i++)
           {
             if(this.restaurantItem[i].Rate==undefined)
             this.restaurantItem[i].Rate=0;
             else if(this.restaurantItem[i].Rate>0)
             {
               this.buttonText="המשך לתשלום";
             this.totalItems+=this.restaurantItem[i].Rate;
            let p=0.0;
            p=this.restaurantItem[i].Price;
            this.totalAmount=Number(this.totalItems)*Number(p);
            if(this.totalAmount>0)
         this.priceTotal=this.clickToPay+""+this.totalAmount+" "+"₪";
         else
         this.priceTotal="0 - פריטים";
         localStorage.PRICE_TOTAL=this.priceTotal;
             }
           }
             this.order=this.orderService.order;
      
          if(this.restaurant.MenuList.length>0)
         {
   

                    // אם קיים ליסט
                    if (this.order?.list) { 

                      //רק מה שגדול מ0 וה
                      //id זהה
                      this.order.list .filter(orderItem => orderItem.Count > 0)  // Only process items with count > 0
                        .forEach(orderItem => {
                          const matchingItem = this.restaurantItem.find(
                            item => item.ID === orderItem.MenuID
                          );
                          
                          if (matchingItem) {
                            matchingItem.Rate += orderItem.Count;
                            if (orderItem.IsAdditionRequired == 1 && orderItem.listSets.length == 0)
                              {
                                localStorage.MENU_ID = orderItem.MenuID;
                                localStorage.MENU_NUMBER = orderItem.MenuNumber;
                                this.openPopup(matchingItem);
                              }
                          }
                        });
                    }


    this.processAdditionalItems()
          if(localStorage.PRICE>0)
          this.totalAmount=Number(localStorage.PRICE)
          else
          {
           this.totalAmount=0;
         for(let i=0;i<this.restaurant.MenuList.length;i++)
         {
           if(this.restaurant.MenuList[i].Rate>0)
           {
             let p:number=0;
             p=this.restaurant.MenuList[i].Price;
             this.totalAmount+=Number(this.restaurantItem[i].Rate)*Number(p);
             this.totalItems+=this.restaurantItem[i].Rate;
           }
         }
       }
    

       }
         if(this.order!=null && this.order.OrderID!=0)
           {
             let haveList=false;
             let pos=-1;
             for(let j=0;j<this.restaurantItem.length;j++)
           
           {
              haveList=false;
              pos=-1;
              for(let i=0;i<this.order.list.length;i++)
             {
         
             if(this.restaurantItem[j].Rate>0)
             {
               pos=j;
             if(this.order.list[i].MenuID==this.restaurantItem[j].ID)
             {
                haveList=true;
                i=this.order.list.length;
             }
           }
             }
             if(pos>0 && haveList==false)
             {
             this.restaurantItem[pos].Rate=0;
             let location = this.restaurantItem[pos].ChangeFood.length-1;
             this.restaurantItem[pos].ChangeFood.splice(this.restaurantItem.length-1,1);
             delete this.restaurantItem[pos].ChangeFood[location]; 
             this.restaurantItem[pos].ChangeFood.length=location;
             let p:number=0;
             p=this.restaurantItem[pos].Price;
             this.totalAmount-=Number(this.restaurantItem[pos].Rate)*Number(p);
             this.totalItems-=this.restaurantItem[pos].Rate;
           }
           }
           } 
     
      });
    }
   }


  changeOnFood(MenuID:number, pos:number ,position:number){
   this.isChangeOnFood = true
    this.restaurant.MenuList=this.restaurantItem;
    this.bussinssService.restaurant=this.restaurant;
    if(this.orderService.restaurant==null)
    this.orderService.restaurant=this.restaurant;
    if(this.restaurant!=null && this.restaurant.MenuList!=null)
    this.orderService.restaurant.MenuList=this.restaurant.MenuList;
    localStorage.PRICE=Number(this.totalAmount);
    localStorage.ITEM=Number(this.totalItems);
    //let pos=position+1;
    localStorage.MENU_ID=MenuID;
    localStorage.MENU_NUMBER=position + 1;
    let a:number=1;
    let b=Number(position-1);
    let have=false;
    if(b>=0)
    for(let i=0;i<this.restaurant.MenuList[pos].ChangeFood.length;i++)
    {
    if(this.restaurant.MenuList[pos].ChangeFood[i].Name==null || this.restaurant.MenuList[pos].ChangeFood[i].Name=="" )
    have=true;
    }
    if(have==true)
    position=Number(position-1);
    position=Number(position+a);
    this.dataService.show.next(true);
     this.changeShowPrice.emit();
        localStorage.edit="false";
        localStorage.position=position;
        localStorage.pos=pos;
    // this.router.navigate(['toppings2']);
     this.openPopup( this.restaurantItem[pos]);
  //  }
  }

  addFevorit()
  {
    if(!localStorage.ACCESS_TOKEN || localStorage.ACCESS_TOKEN  == "null")
    this.router.navigate(['../mainHome']);
    else
    {
    this.clickFevorite=true;
   this.bussinssService.setFavoriteBusiness(this.restaurant.ID).subscribe((res:any)=>{
     if(this.restaurant.IsFevorite==1)
     this.restaurant.IsFevorite=0;
     else
     this.restaurant.IsFevorite=1;
     // this.change.emit();
  });
}
  }

  // category(i){
  //   //this.restaurantItem=null
  //   localStorage.CATEGORY_FILTER=i;
  //   for(let j=0;j<this.categores.length;j++)
  //   {
  //     if(j!=i)
  //     this.categores[j].isCheck=0;
  //   }
  //   if(this.categores[i].isCheck==1)
  //   {
  //      this.categores[i].isCheck=0;
  //      this.categoryToFilter=null;
  //   }
  //   else
  //   {
  //      this.categores[i].isCheck=1;
  //      this.categoryToFilter=this.categores[i].Category;
  //   }
  //    //  if(this.categores[i].isCheck==1)
  //     // this.ngOnInit();
  //     if(localStorage.ID!="0")
  //     if(this.categoryToFilter=="")
  //       this.id=localStorage.ID;
  //       else
  //       this.id=this.restaurant.ID;
  //     if(this.categoryToFilter==null)
  //     this.categoryToFilter="";
  //     if(this.id!=undefined)
  //     this.bussinssService.getRestaurantDetails(this.id,false,false,false,this.categoryToFilter,null).subscribe((res:any)=>{
  //       this.restaurant=res;
  //       this.orderService.restaurant=this.restaurant;
  //       if(this.restaurant.LongImage!=null)
  //       this.Image=this.restaurant.LongImage;
  //       this.restaurantItem=this.restaurant.MenuList;
  //       if(this.restaurantItem!=null)
  //       for(let i=0;i<this.restaurantItem.length;i++)
  //         {
  //           if(this.restaurantItem[i].Rate==undefined)
  //           this.restaurantItem[i].Rate=0;
  //           else if(this.restaurantItem[i].Rate>0)
  //           {
  //             this.buttonText="המשך לתשלום";
  //           this.totalItems+=this.restaurantItem[i].Rate;
  //          let p=0.0;
  //          p=this.restaurantItem[i].Price;
  //          this.totalAmount=Number(this.totalItems)*Number(p);
  //          if(this.totalAmount>0)
  //       this.priceTotal=this.clickToPay+""+this.totalAmount+" "+"₪";
  //       else
  //       this.priceTotal="0 - פריטים";
  //       localStorage.PRICE_TOTAL=this.priceTotal;
  //           }
  //         }
  //         this.orderService.getOrderDetails(false).subscribe((res:any)=>{
  //           this.order=res;
  //         for(let i=0;i<this.order.list.length;i++)
  //         {
  //           for(let j=0;j<this.restaurantItem.length;j++)
  //           {
  //           if(this.order.list[i].MenuID==this.restaurantItem[j].ID)
  //           if(this.order.list[i].Count>0)
  //           this.restaurantItem[j].Rate+=this.order.list[i].Count;
          
  //           for(let j=0;j<this.restaurantItem.length;j++)
  //           {
  //            this.restaurantItem[j].ChangeFood=[];
  //            if(this.restaurantItem[j].ChangeFood==null)
  //               this.restaurantItem[j].ChangeFood=[];
  //           for(let q=0;q<this.restaurantItem[j].Rate;q++)
  //           {
  //            let changeFood = new ChangeFood();
          
  //               //this.restaurantItem[j].Rate;
  //            // changeFood.Name =(Number(j+1))+'-'+ this.restaurantItem[j].Name;
  //             changeFood.Text="לחץ לשינויים ";
  //            changeFood.toppings =null; 
     
  //              changeFood.Name =(Number(q+1))+'-'+ this.restaurantItem[j].Name;
  //              this.restaurantItem[j].ChangeFood.push(changeFood);
  //           }
  //         }
  //           }
  //         }});
  //     });
  //  }

   bigImage(i)
   {
      // const dialogConfig = new MatDialogConfig();
      // this.matDialog.open(BigImageComponent, { disableClose: true });
      //  this.matDialog.open(BigImageComponent, {
      //   width: '330px',
      //   height: '400px',
      //   data: {
      //     dataKey: this.restaurantItem[i].Image
      //   }
        
      // });
      let dialogRef = this.matDialog.open(BigImageComponent, {
        disableClose: true,
    });
dialogRef.componentInstance.url = this.restaurantItem[i].Image;
   }


 
  
  scrollToTop(): void {
    setTimeout(() => window.scroll(0, 0), 0);
  }
}
